/* eslint-disable no-param-reassign */
import axios from 'axios';
import { get, camelCase, has } from 'lodash';
import Resource from '../resource';
import ApiModule from '../api-module';

class Endpoint extends ApiModule {
  public endpoint;

  constructor({ url: baseURL, options = {}, headers, ...rest }) {
    super(rest);

    this.endpoint = axios.create({
      baseURL,
      headers,
      ...options,
    });
  }

  resources = {};

  registerResources = (
    ...resources: { name: string; path: string }[]
  ): Endpoint => {
    this.resources = resources.reduce((resources, resource) => {
      if (resource instanceof Resource) {
        return {
          ...resources,
          [resource.name]: resource.setEndpoint(this.endpoint),
        };
      }
      return {
        ...resources,
        [resource.name]: this.setResource(resource),
      };
    }, this.resources);

    return this;
  };

  setResource = ({ name, path, ...rest }) => {
    name = name ? name : camelCase(path.replace('/', ''));
    const resourceProperties = {
      name,
      path,
      endpoint: this.endpoint,
      ...rest,
    };

    this.resources[name] = new Resource(resourceProperties as any);
    return this.resources[name];
  };

  getResource = (key): ApiModule => {
    if (has(this.resources, key)) {
      return get(this.resources, key);
    }

    throw new Error(`Resource with name ${key} does not exist.`);
  };

  getUrl = () => {
    return this.endpoint.baseURL;
  };
}

export default Endpoint;
